<template>
    <span>{{prefix}}<template v-if="gold > 0">{{gold}}<IconGold/></template><template v-if="silver > 0 || gold > 0">{{silver}}<IconSilver/></template>{{copper}}<IconCopper/></span>
</template>

<script>
    import IconCopper from "./IconCopper.vue"
    import IconSilver from "./IconSilver.vue"
    import IconGold from "./IconGold.vue"

    export default {
        name: 'GoldAmount',
        components: {
            IconCopper,
            IconSilver,
            IconGold
        },
        props: {
            amount: {
                required: true
            }
        },
        computed: {
            prefix: function() {
                return this.amount < 0 ? "-" : ""
            },
            copper: function() {
                return Math.round(((this.amount > 0 ? this.amount : -this.amount) % 100) * 10) / 10;
            },
            silver: function() {
                return Math.floor((this.amount > 0 ? this.amount : -this.amount) / 100 % 100);
            },
            gold: function() {
                return Math.floor((this.amount > 0 ? this.amount : -this.amount) / 10000);
            },
        }
    }
</script>

<style scoped>
    span {
        display: inline-flex;
    }
</style>
